import { computed } from 'vue'


export default {
  __name: 'AppProductBadge',
  props: {
  type: {
    type: String,
    required: true,
    validator: (value) => {
      return [
        'new',
        'hot',
        'animated',
        'official',
        'staff-pick',
        'ultimate',
        'staff-pick',
        'bestseller',
        'licensed',
        'exclusive'
      ].includes(value)
    }
  },
  hasIcon: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props



const types = {
  new: {
    class: 'text-white bg-pink-400 border-pink-400',
    icon: 'far fa-sparkles',
    i18n: 'new'
  },
  hot: {
    class: 'text-white bg-red-400 border-red-400',
    icon: 'far fa-fire',
    i18n: 'hot'
  },
  animated: {
    class: 'text-white bg-purple-800 border-purple-800',
    icon: 'far fa-walking',
    i18n: 'animated'
  },
  official: {
    class: 'text-white bg-white bg-opacity-12 border-white border-opacity-6',
    icon: 'fas fa-badge-check text-yellow-300',
    i18n: 'official'
  },
  'staff-pick': {
    class: 'text-white bg-blue-100 border-blue-100',
    icon: 'far fa-medal',
    i18n: 'staff_pick'
  },
  ultimate: {
    class: 'text-white bg-green-400 border-green-400',
    icon: 'far fa-trophy',
    i18n: 'ultimate'
  },
  exclusive: {
    class: 'text-yellow-300 border-yellow-300',
    i18n: 'exclusive'
  }
}

const currentType = computed(() => {
  if (props.type === 'bestseller') {
    return types['staff-pick']
  }

  if (props.type === 'licensed') {
    return types.official
  }

  return types[props.type]
})


return { __sfc: true,props, types, currentType, computed }
}

}